<template>
  <TheGlobalLoading />
</template>

<script>
import rebrand from '../../../config/rebrand';
import TheGlobalLoading from '../../Layout/components/TheGlobalLoading';

export default {
  name: 'AuthLogout',
  components: { TheGlobalLoading },
  data() {
    return {
      logoutUrl: `${rebrand.urls.KLICKART_URL}/crossapp/logout`,
    };
  },
  async mounted() {
    window.location.href = this.logoutUrl;
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Auth/components/Logout.vue